<div id="quickActions" class="chat-actions" *ngIf="showActions()" [attr.aria-expanded]="showActions()">
  <ul>
    <li class="ng-scope" *ngIf="display.size !== 'xsmall'">
      <button (click)="closeChat()" class="quickActionIcon" [disabled]="getConferenceButton()">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_echange_terminer"></span>
        <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.close_chat_button_title' | translate }}</span>
        <span class="nodisplay">{{ 'agent:panel.chat.actions.close_chat_conversation_button_title' | translate }}</span>
      </button>
    </li>
    <li class="ng-scope" *ngIf="display.size !== 'xsmall' && enableTransfer">
      <button
        (click)="transfer(false)"
        class="quickActionIcon"
        [disabled]="
          getConferenceButton() || closeFromVisitor || alreadySharingScreen || !fileUploadInProgress() || conversationCloseByTheClient
        "
      >
        <span aria-hidden="true" class="quickActionIconBg cng-ico_transfert"></span>
        <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.transfer_chat_button_title' | translate }}</span>
        <span class="nodisplay">{{ 'agent:panel.chat.actions.transfer_chat_conversation_button_title' | translate }}</span>
      </button>
    </li>
    <li class="ng-scope" *ngIf="!getConferenceButton() && enableConference && display.size !== 'xsmall'">
      <button
        (click)="transfer(true)"
        class="quickActionIcon"
        [disabled]="closeFromVisitor || alreadySharingScreen || !fileUploadInProgress() || conversationCloseByTheClient"
      >
        <span aria-hidden="true" class="quickActionIconBg cng-ico_conf3"></span>
        <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.conference_chat_button_title' | translate }}</span>
        <span class="nodisplay">{{ 'agent:panel.chat.actions.conference_chat_conversation_button_title' | translate }}</span>
      </button>
    </li>
    <li class="ng-scope" *ngIf="getConferenceButton() && display.size !== 'xsmall'">
      <button (click)="leaveConference()" class="quickActionIcon" [disabled]="!fileUploadInProgress()">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_conf3_end"></span>
        <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.leave_conference_chat_button_title' | translate }}</span>
      </button>
    </li>

    <li *ngIf="display.size !== 'large'">
      <button class="quickActionIcon" (click)="toggleMoreMenu = !toggleMoreMenu" [attr.aria-expanded]="toggleMoreMenu">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_menu_bullets"></span>
        <span class="quickActionLabel">{{ 'commons:basic.actions' | translate }}</span>
      </button>
      <div class="quickActions-moreMenu" *ngIf="toggleMoreMenu" (mouseleave)="toggleMoreMenu = false">
        <ul>
          <li class="mainAction cng-ico_annuler" *ngIf="display.size === 'xsmall'">
            <button (click)="closeChat()">
              <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.close_chat_button_title' | translate }}</span>
              <span class="nodisplay">{{ 'agent:panel.chat.actions.close_chat_conversation_button_title' | translate }}</span>
            </button>
          </li>
          <li class="mainAction cng-ico_transfert" *ngIf="display.size === 'xsmall' && enableTransfer">
            <button (click)="transfer(false)" [disabled]="getConferenceButton() || closeFromVisitor || conversationCloseByTheClient">
              <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.transfer_chat_button_title' | translate }}</span>
              <span class="nodisplay">{{ 'agent:panel.chat.actions.transfer_chat_conversation_button_title' | translate }}</span>
            </button>
          </li>
          <li class="mainAction cng-ico_conf3" *ngIf="display.size === 'xsmall' && enableConference">
            <button (click)="transfer(true)" [disabled]="closeFromVisitor || alreadySharingScreen || conversationCloseByTheClient">
              <span class="quickActionLabel ng-binding">{{ 'agent:panel.chat.actions.conference_chat_button_title' | translate }}</span>
              <span class="nodisplay">{{ 'agent:panel.chat.actions.conference_chat_conversation_button_title' | translate }}</span>
            </button>
          </li>
          <li class="mainAction cng-ico_conf3_end" *ngIf="display.size === 'xsmall'">
            <button (click)="leaveConference()">
              <span aria-hidden="true" class="quickActionIconBg cng-ico_conf3_end"></span>
              <span class="quickActionLabel ng-binding">{{
                'agent:panel.chat.actions.leave_conference_chat_button_title' | translate
              }}</span>
            </button>
          </li>

          <li *ngIf="hasPermission('CSR::contact:sms_push')">
            <button (click)="openSMSForm()">{{ 'agent:contact.actions.send_SMS' | translate }}</button>
          </li>
          <li *ngIf="canOpenUnitMail()">
            <button (click)="openUnitMail()">{{ 'agent:contact.actions.send_mail' | translate }}</button>
          </li>
          <li *ngIf="canOpenOutcall()">
            <button [disabled]="!havePhoneAddress || outcallDisabled()" (click)="openOutcall()">
              {{ 'agent:contact.actions.outgoing_call' | translate }}
            </button>
          </li>
          <li *ngIf="hasPermission('CSR::campaign_appointment:create')">
            <button (click)="openAppointmentForm()">
              {{ 'agent:contact.actions.take_an_appointment' | translate }}
            </button>
          </li>
          <li
            *ngIf="!alreadySharingScreen && enableMirroring"
            [ngClass]="{
              disabled: screenSharingDemandPending || hasScreenSharing || visitorHasNoCapabilityForScreenSharing || getConferenceButton()
            }"
          >
            <button (click)="askForScreenSharing()">{{ 'agent:panel.chat.actions.screen-sharing.demand' | translate }}</button>
          </li>
          <li *ngIf="alreadySharingScreen">
            <button (click)="forceStopScreenSharing()">{{ 'agent:panel.chat.actions.screen-sharing.stop' | translate }}</button>
          </li>
          <li *ngIf="canRedirectToScriptAnchor">
            <button (click)="scriptRedirect()">{{ 'agent:contact.actions.put_in_script' | translate }}</button>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
<div id="moreActions" *ngIf="display.size === 'large' && !chatSocketService.websocketLost">
  <ul>
    <li *ngIf="hasPermission('CSR::contact:sms_push')">
      <button [disabled]="!havePhoneAddress" (click)="openSMSForm()">{{ 'agent:contact.actions.send_SMS' | translate }}</button>
    </li>
    <li *ngIf="canOpenUnitMail()">
      <button [disabled]="!haveMailAddress" (click)="openUnitMail()">{{ 'agent:contact.actions.send_mail' | translate }}</button>
    </li>
    <li *ngIf="canOpenOutcall()">
      <button [disabled]="!havePhoneAddress || outcallDisabled()" (click)="openOutcall()">
        {{ 'agent:contact.actions.outgoing_call' | translate }}
      </button>
    </li>
  </ul>
  <ul>
    <li *ngIf="hasPermission('CSR::campaign_appointment:create')">
      <button (click)="openAppointmentForm()">{{ 'agent:contact.actions.take_an_appointment' | translate }}</button>
    </li>
    <li
      *ngIf="!alreadySharingScreen && enableMirroring"
      [ngClass]="{
        disabled: screenSharingDemandPending || hasScreenSharing || visitorHasNoCapabilityForScreenSharing || getConferenceButton()
      }"
    >
      <button (click)="askForScreenSharing()">{{ 'agent:panel.chat.actions.screen-sharing.demand' | translate }}</button>
    </li>
    <li *ngIf="alreadySharingScreen">
      <button (click)="forceStopScreenSharing()">{{ 'agent:panel.chat.actions.screen-sharing.stop' | translate }}</button>
    </li>
    <li *ngIf="canRedirectToScriptAnchor">
      <button (click)="scriptRedirect()">{{ 'agent:contact.actions.put_in_script' | translate }}</button>
    </li>
  </ul>
</div>
